export default "__VITE_ASSET__CaFGvGeH__"